module.exports = __webpack_public_path__ + "static/media/Other.d1c758ae.svg";